import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import NewArticleCategoryStore from "./NewArticleCategoryStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import SellerNameInput from "../../Inputs/SellerNameInput/SellerNameInput";
import {useStyles} from "./NewArticleCategoryButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ArticleDescriptionInput from '../../Inputs/ArticleDescriptionInput/ArticleDescriptionInput';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import NewArticleCategoryButtonProperties from './NewArticleCategoryButtonProperties';
import { useUserContext } from '../../../contexts/UserContext';


const NewArticleCategoryButton: React.FC<NewArticleCategoryButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  articleCategoryId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new NewArticleCategoryStore(commonContext, articleCategoryId);

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onNameChange = (newName: string) => store.articleCategory.name = newName;
    const onDescriptionChange = (newDescription: string) => store.articleCategory.description = newDescription;
    
    const onArticleCategorySave = async () => {
        if (!store.enableButton) {
            return;
        }
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    const text = i18n.translate((store.isEditing ? "EDIT_ARTICLE_CATEGORY" : "NEW_ARTICLE_CATEGORY"));
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <SellerNameInput error={i18n.translate(store.nameError)}
                            autoFocus fullWidth className={classes.input}
                            value={store.articleCategory?.name}
                            onChange={onNameChange}/>
                        <ArticleDescriptionInput fullWidth className={classes.input}
                                    value={store.articleCategory?.description}
                                    onChange={onDescriptionChange}/>
                        <Button
                            disabled={!store.enableButton}
                            loading={store.loading} className={classes.input} onClick={onArticleCategorySave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewArticleCategoryButton;

